import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: "AIzaSyDvz6AmIHtVj8ihZC74pf01uxiab5jsupU",
  authDomain: "sft-site-management.firebaseapp.com",
  projectId: "sft-site-management",
  storageBucket: "sft-site-management.firebasestorage.app",
  messagingSenderId: "339310927527",
  appId: "1:339310927527:web:1d731d89f220fd3c18c582",
};

const app = initializeApp(firebaseConfig);

// App Check — anti-abuse / bot resistance for Firestore + callable Functions.
// Safe no-op until you register a reCAPTCHA v3 site key in the Firebase console
// and set REACT_APP_APPCHECK_SITE_KEY (in .env.local for dev). Until then this
// does nothing, so it can't break the app; once enforced in the console it
// blocks unauthenticated clients that lack a valid App Check token.
const APPCHECK_SITE_KEY = process.env.REACT_APP_APPCHECK_SITE_KEY;
let appCheck = null;
if (APPCHECK_SITE_KEY) {
  try {
    appCheck = initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(APPCHECK_SITE_KEY),
      isTokenAutoRefreshEnabled: true,
    });
  } catch (e) {
    // Never let App Check init crash app start-up.
    console.warn("App Check init skipped:", e?.message || e);
  }
}

// Exported so raw fetch() calls to our onRequest Cloud Functions can attach an
// App Check token (see src/utils/appCheck.js). null when the site key is unset.
export { appCheck };
export const db = getFirestore(app);
export const auth = getAuth(app);